// extracted by mini-css-extract-plugin
module.exports = {"fragment":"Fragment__fragment___1Ro1_","tpb":"Fragment__tpb___21xcl"};